import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, map, Observable, tap } from 'rxjs';
import { CertificateStoreActions, CertificateStoreStates } from '../certificate';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';

@Injectable()
export class CertificateResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly certificateStore: Store<CertificateStoreStates.CertificateState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.certificateStore.dispatch(
          CertificateStoreActions.CertificateResolverActions.certificatesRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
